module.exports = __webpack_public_path__ + "8a5356e9/img/link-icon.fa09ed66.svg";